module.exports = __webpack_public_path__ + "img/bg1.4c0f05fe.jpg";